import { AppState, Auth0Provider } from '@auth0/auth0-react';
import { CssBaseline } from '@mui/material';
import {
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  TimeScale,
  Title,
  Tooltip,
} from 'chart.js';
import 'chartjs-adapter-moment';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/components/App';
import AppThemeProvider from './app/components/theme/AppThemeProvider';
import { getConfig } from './auth/config/auth-config';
import { navigate } from './common/routing/app-navigator';
import { initGoogleAnalytics } from './google-analytics/actions/google-analytics-actions';
import reportWebVitals from './reportWebVitals';
import './reset.css';
import ZoomPlugin from 'chartjs-plugin-zoom';

// init stuff before bootstrap
initGoogleAnalytics();
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  TimeScale,
  ZoomPlugin,
);

const onRedirectCallback = (appState?: AppState) => {
  const pathname =
    appState && appState.returnTo
      ? appState.returnTo
      : window.location.pathname;
  navigate(pathname);
};

export const bootstrap = () => {
  // Please see https://auth0.github.io/auth0-react/interfaces/auth0_provider.auth0provideroptions.html
  // for a full list of the available properties on the provider
  const config = getConfig();

  const providerConfig = {
    domain: config.domain,
    clientId: config.clientId,
    ...(config.audience ? { audience: config.audience } : null),
    redirectUri: window.location.origin,
    onRedirectCallback,
  };

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
  );

  root.render(
    <Auth0Provider {...providerConfig}>
      <AppThemeProvider>
        <CssBaseline enableColorScheme />
        <App />
      </AppThemeProvider>
    </Auth0Provider>,
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
};
